import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-81409QEB9F";

function gtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

// Fire a custom GA4 event.
export function trackEvent(name, params = {}) {
  gtag("event", name, params);
}

// SPA route tracking + global WhatsApp / phone click tracking.
// Mount once inside the Router.
export default function AnalyticsTracker() {
  const location = useLocation();
  const first = useRef(true);

  // Page views on client-side route changes (initial view is auto-sent by gtag config).
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    gtag("config", GA_ID, { page_path: location.pathname + location.search });
    gtag("event", "page_view", { page_path: location.pathname + location.search });
  }, [location]);

  // One delegated listener for all WhatsApp (wa.me) and phone (tel:) links.
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (href.includes("wa.me") || href.includes("api.whatsapp.com")) {
        trackEvent("whatsapp_click", { link_url: href, page_path: window.location.pathname });
      } else if (href.startsWith("tel:")) {
        trackEvent("phone_click", { link_url: href, page_path: window.location.pathname });
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
}
